export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
    <rect x="5" y="5" width="54" height="54" stroke="currentColor" strokeWidth="4" opacity="0.9" />
    <path d="M23 20h10a7 7 0 0 1 0 14H23V20zm0 14h12a7 7 0 0 1 0 14H23V34z" fill="currentColor" />
    <rect x="46" y="5" width="13" height="13" fill="#D96B27" />
  </svg>
);

export const Logo = ({ onClick }) => (
  <a
    href="#"
    onClick={onClick}
    data-testid="logo-home-link"
    className="flex items-center gap-2.5 text-[#F4F1EA] select-none"
    aria-label="BoomGradnja"
  >
    <LogoMark className="w-8 h-8 sm:w-9 sm:h-9" />
    <span className="font-display font-extrabold tracking-wide text-lg sm:text-xl leading-none">
      <span className="text-[#D96B27]">BOOM</span>GRADNJA
    </span>
  </a>
);
